/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React, { useState, useEffect, useRef } from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import DateTimePicker from 'react-datetime-picker';
import { Dropdown } from 'semantic-ui-react';
import ChartCard from '../Chart/ChartCard';

import { lineOptions } from '../../utils/demo/chartsData';

import styles from './Report.module.scss';

const ReportContent = React.memo(({ type, reports, onChangeDate }) => {
  const { reportItems, energy } = reports;

  const chartRef = useRef();
  const [listDevices, setListDevices] = useState([]);
  const [listItems, setListItems] = useState([]);

  let dateFilterShowFormat = 'y-MM-dd';
  let dateFilterFormat = 'yMMdd';
  switch (type) {
    case 'monthly': {
      dateFilterShowFormat = 'y-MM';
      dateFilterFormat = 'yMM';
      break;
    }
    case 'yearly': {
      dateFilterShowFormat = 'y';
      dateFilterFormat = 'y';
      break;
    }
    default:
  }

  const [dateValue, setDateChange] = useState(new Date());
  const [filterItem, setfilterItem] = useState();
  const [filterDevice, setfilterDevice] = useState([]);
  const [dataValue, setDataValue] = useState();
  const [options, setOptions] = useState({});

  const getfilterItem = (event, { value }) => {
    setfilterItem(value);
  };
  const getfilterDevice = (event, { value }) => {
    setfilterDevice(value);
  };

  const onDateChange = (value) => {
    setDateChange(value);
    const datevalue = format(value, dateFilterFormat);
    onChangeDate(datevalue);
  };

  useEffect(() => {
    if (reportItems) {
      const newListDevices = [];
      energy.forEach((itemDevice, index) => {
        newListDevices.push({
          key: index,
          value: itemDevice.device.id,
          text: itemDevice.device.name,
        });
      });
      setListDevices(newListDevices);
      setfilterDevice(newListDevices[0] ? [newListDevices[0].value] : []);

      const newListItems = [];
      reportItems.forEach((itemItem, index) => {
        newListItems.push({
          key: index,
          value: itemItem.itemName,
          text: itemItem.name,
          unit: itemItem.unitName,
        });
      });
      setListItems(newListItems);
      setfilterItem(newListItems[0] ? newListItems[0].value : 0);
    }
  }, [energy, reportItems]);

  useEffect(() => {
    if (reportItems) {
      const reportItem = reportItems.find((it) => it.itemName === filterItem);
      if (filterItem) {
        const datasets = [];
        let maxY = 1;
        if (filterDevice.length > 0) {
          filterDevice.forEach((device, index) => {
            const data_values = energy.find((element) => element.device.id === device);

            let dataChart = [];
            if (data_values) {
              dataChart = data_values[reportItem.itemName];
            }
            const newMaxY = Math.max(...dataChart) * 1.5;
            if (newMaxY > maxY) {
              if (newMaxY < 10) {
                maxY = newMaxY.toFixed(1);
              } else {
                maxY = newMaxY.toFixed(0);
              }
            }

            const randomColor = Math.floor(Math.random() * 16777215).toString(16);
            datasets.push({
              type: reportItem.graphType,
              label: data_values?.device?.name || '',
              borderColor: `#${randomColor}`,
              borderWidth: 1,
              backgroundColor: reportItem.graphType === 'line' ? 'transparent' : `#${randomColor}`,
              pointBorderColor: 'transparent',
              fill: false,
              data: dataChart,
            });
          });
        }

        const data_labels = [];
        for (let i = 0; i < datasets[0]?.data?.length; i += 1) {
          data_labels.push(i + 1);
        }

        setDataValue({
          labels: data_labels,
          datasets,
        });

        setOptions({
          responsive: true,
          scales: {
            yAxes: [
              {
                type: 'linear',
                display: true,
                position: 'left',
                id: `y_axis_${reportItem.unitName}`,
                scaleLabel: {
                  display: false,
                  labelString: reportItem.name,
                },
                ticks: {
                  display: true,
                  max: maxY,
                  min: 0,
                  callback(value) {
                    return `${value} ${reportItem.unitName}`;
                  },
                },
              },
            ],
            xAxes: [
              {
                ticks: {
                  display: true,
                },
              },
            ],
          },
        });
      }
    }
  }, [energy, reportItems, filterDevice, filterItem]);

  useEffect(() => {
    setfilterDevice(listDevices[0] ? [listDevices[0].value] : []);
    setfilterItem(listItems[0] ? listItems[0].value : 0);
  }, [listDevices, listItems, type]);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.chartInstance.update();
    }
  }, [options, type]);

  return (
    <>
      {listItems.length > 0 && (
        <div className={styles.reportFilter}>
          {listDevices.length > 0 && (
            <Dropdown
              className={styles.filterItems}
              defaultValue={listDevices[0]?.value || 0}
              search
              selection
              multiple
              options={listDevices}
              onChange={getfilterDevice}
            />
          )}
          <Dropdown
            className={styles.filterItems}
            defaultValue={listItems[0].value}
            search
            selection
            options={listItems}
            onChange={getfilterItem}
          />
          <DateTimePicker
            className={styles.filterDate}
            onChange={onDateChange}
            value={dateValue}
            format={dateFilterShowFormat}
          />
        </div>
      )}
      <div className={styles.tableWrapper}>
        <ChartCard title="">
          <>
            {dataValue && options && (
              <Bar
                ref={chartRef}
                reftype="line"
                data={dataValue}
                options={options}
                legend={lineOptions.legend}
              />
            )}
          </>
        </ChartCard>
      </div>
    </>
  );
});

ReportContent.propTypes = {
  type: PropTypes.string.isRequired,
  reports: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeDate: PropTypes.func.isRequired,
};

export default ReportContent;
